module.exports = __webpack_public_path__ + "img/blink3.8cebf7bb.png";